export class Events {
  static PVS_PHOTO = 'Post Visit Summary Photo';
}

export class Actions {
  static CLICK_UPLOAD_FILE = 'click upload file';

  static CLICK_VIEW_FILE = 'click view file';

  static SEE_PHOTO_UPLOAD_CTA = 'see photo upload CTA';
}
